import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cookieBox"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "bg" }, null, -1)
const _hoisted_3 = { class: "box" }
const _hoisted_4 = { class: "left" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "msg" }
const _hoisted_7 = { class: "right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    (_ctx.cookieBox)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.languageData.index_78), 1),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.languageData.index_79), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                class: "btn",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.acceptCookie && _ctx.acceptCookie(...args)))
              }, _toDisplayString(_ctx.languageData.index_80), 1),
              _createElementVNode("div", {
                class: "btn2",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rejectCookie && _ctx.rejectCookie(...args)))
              }, _toDisplayString(_ctx.languageData.index_81), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}